import React from 'react';
import { css } from '@emotion/react';
import styled from '../../../libs/styled.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function thoundsandDelimiter(number) {
  if (!number) {
    return "0";
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
const StyledCurrency = styled.span`
  width: max-content;
  display: inline-block;
`;
const Text = styled.span(({ underline }) => css`
    text-decoration: ${underline ? "underline" : ""};
  `);
const Currency = (_a) => {
  var _b = _a, {
    value,
    hideCurrency = false,
    space = false,
    underline = false
  } = _b, props = __objRest(_b, [
    "value",
    "hideCurrency",
    "space",
    "underline"
  ]);
  if (!value && value !== 0) {
    return /* @__PURE__ */ React.createElement(StyledCurrency, __spreadValues({}, props), "\xA0");
  }
  return /* @__PURE__ */ React.createElement(StyledCurrency, __spreadValues({}, props), thoundsandDelimiter(value), !hideCurrency && /* @__PURE__ */ React.createElement(React.Fragment, null, space && " ", /* @__PURE__ */ React.createElement(Text, {
    underline
  }, "\u0111")));
};

export { Currency, thoundsandDelimiter };
